import { render, staticRenderFns } from "./MyPlaylists.vue?vue&type=template&id=0984ac57&scoped=true"
import script from "./MyPlaylists.vue?vue&type=script&lang=js"
export * from "./MyPlaylists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984ac57",
  null
  
)

export default component.exports